import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CloseBill, History, Loader, NoteDrawer, SimpleTabs, VoidedButton } from 'components';
import {
  customerActions,
  customerPaymentActions,
  httpRequestsOnLoadActions,
  httpRequestsOnSuccessActions,
} from 'store';
import { FindLoad, Images, PermissionsList, RolePermission, useModal, useTertiaryModal } from 'utils';
import { CustomerPaymentInfoFragment } from './customerPaymentDetails';
import { checkStatus } from './customerPaymentDetails/constants';
import { CustomDeleteModal } from '../modals';
import { authService } from '../../store/customerPayment/customerPayment.service';

const ACTION_TYPE = 'GET_CUSTOMER_PAYMENT_BY_ID';
const CUSTOMER_PAYMENT_VOIDED = 'CUSTOMER_PAYMENT_VOIDED';

export const CustomerPaymentInfo = ({ id, afterSuccess }) => {
  const { customerPaymentById, customerPaymentLoad } = useSelector((state) => ({
    customerPaymentById: state.customerPayments.customerPaymentById,
    customerPaymentLoad: state.customerPayments.customerPaymentLoad,
  }));
  const dispatch = useDispatch();
  const { closeTertiary } = useTertiaryModal();
  const [tab, setTab] = useState('Payment Details');
  const loader = FindLoad(ACTION_TYPE);
  const { open, close } = useModal();

  useEffect(() => {
    dispatch(customerActions.getCustomers({ status: 'ACTIVE' }));
    // dispatch(mcActions.getMcs({ status: 'ACTIVE' }));
    dispatch(customerPaymentActions.getCustomerPaymentById(id));
    dispatch(customerPaymentActions.getCustomerPaymentLoad(id));
  }, []);

  const tabsLabels = [
    {
      label: 'Payment Details',
    },
    {
      label: 'History',
    },
  ];

  const tabsContent = [
    {
      tabComponent: <CustomerPaymentInfoFragment
        afterSuccess={afterSuccess}
        pmtId={id}
        info={customerPaymentById}
        customerPaymentLoad={customerPaymentLoad}
      />,
      tab: 'Payment Details',
    },
    {
      tabComponent: <History onModel={'customerPmt'} resourceId={id} />,
      tab: 'History',
    },
  ];

  const handleVoidPayment = async () => {
    dispatch(httpRequestsOnSuccessActions.removeSuccess(CUSTOMER_PAYMENT_VOIDED));
    dispatch(httpRequestsOnLoadActions.appendLoading(CUSTOMER_PAYMENT_VOIDED));
    try {
      await authService.voidCustomerService(id);
      dispatch(customerPaymentActions.getCustomerPaymentById(id, 'noLoad'));
      dispatch(customerPaymentActions.getCustomerPaymentLoad(id));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(CUSTOMER_PAYMENT_VOIDED));
      close();
    } finally {
      dispatch(httpRequestsOnLoadActions.removeLoading(CUSTOMER_PAYMENT_VOIDED));
    }
  };

  if (loader.length) return <div className="customer-payment-info-modal"><Loader /></div>;

  return (
    <div className="customer-payment-info-modal">
      <div className="customer-payment-info-head">
        <p className="customer-payment-info-title">Payment Details</p>
        <div className="flex-align-center" style={{ gap: 18 }}>
          <NoteDrawer title={'Customer Payment'} customParams={{ id: id }} />
          <button className="reset-btn" onClick={closeTertiary}>
            <img src={Images.closeBtn} alt={'print'} />
          </button>
        </div>
      </div>

      <SimpleTabs
        head={
          <div style={{ marginTop: '-3px', marginRight: '-22px' }}>
            {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.VOID_CUSTOMER_PAYMENT?.code]) &&
            customerPaymentById && checkStatus(customerPaymentById) ?
              <CloseBill
                resetStyles={{ height: 32 }}
                text={'Void'}
                width={'77px'}
                handleCLick={() => open(
                  <CustomDeleteModal
                    actionType={CUSTOMER_PAYMENT_VOIDED}
                    type={'void'}
                    text={'Void Payment?'}
                    modalText={'Are you sure you want to void this payment?'}
                    handleDel={handleVoidPayment}
                  />,
                )}
              />
              :
              <VoidedButton />
            }
          </div>
        }
        noBread={true}
        border={'blue'}
        height={'full'}
        tabsLabels={tabsLabels}
        tabsContent={tabsContent}
        defaultTab={tab}
        getTab={(tab) => setTab(tab)}
        useDefault={true}
        bodyStyle={{ background: '#F7F9FC', minHeight: '50vh' }}
      />
    </div>
  );
};